export interface SourceContextInput {
  typeLabel?: string | null;
  relationshipLabel?: string | null;
  anchorLabel?: string | null;
}

const MAX_CONTEXT_CHARS = 48;

function clean(value: string | null | undefined): string {
  return (value ?? "").replace(/\s+/g, " ").trim();
}

function shorten(value: string): string {
  if (value.length <= MAX_CONTEXT_CHARS) return value;
  return `${value.slice(0, MAX_CONTEXT_CHARS - 1).trimEnd()}.`;
}

export function sourceContextLine(input: SourceContextInput): string {
  const type = clean(input.typeLabel) || "Source";
  const rel = clean(input.relationshipLabel).toLowerCase();
  const anchor = clean(input.anchorLabel);

  if (rel === "commentary" || rel === "comments on this") {
    return shorten(anchor ? `${type} on ${anchor}` : `${type} on this source`);
  }
  if (rel.includes("cross-reference")) return shorten(`${type} cross-reference`);
  if (rel.includes("cited")) return shorten(`${type} cited here`);
  if (rel.includes("translation")) return shorten(`${type} translation context`);
  if (rel.includes("connected")) return shorten(`${type} connected here`);
  return shorten(`${type} connected here`);
}
